module.exports = __webpack_public_path__ + "static/media/book.de3e35e6.png";